import Button from './Button'

export default Button



// WEBPACK FOOTER //
// ./src/app/elements/ButtonV2/index.js